// extracted by mini-css-extract-plugin
export default {"ConnectWrapper":"connect_ConnectWrapper__cypHO","BoxWrapper":"connect_BoxWrapper__oR8Kw","SubscriptionBox":"connect_SubscriptionBox__Rp-s0"};